/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Under_ConstructionInputs */

const cs_enum_under_construction = /** @type {(inputs: Enum_Under_ConstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ve výstavbě`)
};

const en_enum_under_construction = /** @type {(inputs: Enum_Under_ConstructionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under construction`)
};

/**
* | output |
* | --- |
* | "Under construction" |
*
* @param {Enum_Under_ConstructionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_under_construction = /** @type {((inputs?: Enum_Under_ConstructionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Under_ConstructionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_under_construction(inputs)
	return cs_enum_under_construction(inputs)
});